import styled from "styled-components";

export const StyledFourthSection = styled.section`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    padding-bottom: 3rem;
    padding-top: 1rem;
`;
export const StyledSecondArticle = styled.article`
    margin: 2rem;
    width: 17rem;
    min-height: 25rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-around;
`;
